export const CLEAR_UNSUPPORTED_QUALIFIER_PRICES = "CLEAR_UNSUPPORTED_QUALIFIER_PRICES"

const clearUnsupportedQualifierPrices = () => dispatch => {
  dispatch({
    type: CLEAR_UNSUPPORTED_QUALIFIER_PRICES
  })
}

export default clearUnsupportedQualifierPrices